import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProgramEditor.html?raw';

import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import lang from 'dojo/_base/lang';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import Edit from '../../moreCore/UI/Edit/Edit';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import VoiceAttributeEditForm from '../VoiceAttributeEditForm/VoiceAttributeEditForm';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';

class EvProgramEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    authorInput: MdsLax<InstanceType<typeof Edit>>;
    titleInput: MdsLax<InstanceType<typeof Edit>>;
    durationInput: MdsLax<InstanceType<typeof NumberInput>>;
    publishInput: MdsLax<InstanceType<typeof CheckBox>>;
    voiceAttributeContainer: MdsLax<InstanceType<typeof ExpandableSection>>;
    voiceAttributeEditForm: MdsLax<InstanceType<typeof VoiceAttributeEditForm>>;
    private inputStatus: MdsLax<InstanceType<typeof SearchSelect>>;

    protected afterSetData() {
        if (this.getAttributeValue("ref_opus")) {
            this.authorInput.setReadonly(true);
            this.titleInput.setReadonly(true);
        } else {
            this.UiModder.domClass.toggle(this.authorInput.inputNode, "w3-text-red", true);
            this.UiModder.domClass.toggle(this.titleInput.inputNode, "w3-text-red", true);
            this.UiModder.domClass.toggle(this.durationInput.fakeInputNode, "w3-text-red", true);


            //this.voiceAttributeEditForm.destroy();
            //this.hideNode(this.voiceAttributeContainer, true);
        }
        this.voiceAttributeContainer.setMarking(ExpandableSectionMarkings.hasContent);

        if (this.hasFeature("Planning/EvProgramStatus") && this.inputStatus) {
            let status = this.getAttributeValue("ref_ev_program_status");
            this._loadStatusValues(status);
        }

    }

    private _loadStatusValues(status: more.EntityAPIResultExtended) {
        this.RequestManager.callfunction("Webtool_API__EvProgramEditor_LoadStatusValues", {}, lang.hitch(this, this._onLoadStatusValuesResponse, status), lang.hitch(this, this._onLoadStatusValuesError));
    }

    private _onLoadStatusValuesResponse(status: more.EntityAPIResultExtended, response) {
        this.inputStatus.setData(status, response);
    }

    private _onLoadStatusValuesError(error) {
        console.error(error);
    }

    setup(program: VAM2types.EvProgram | VAM2types.EvProgramEvProject) {
        this.setData(program);

        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm))

        this.show("dlg", program.$Displayname);
        this._uiFrameDlg.enableContentOverflow(true);

    }

    private _onIsEncoreChange(e) {
        if (e) {
            this.publishInput.setValue(false);
        }
    }

    private _onClickConfirm() {
        this.emit("confirmed", this.getCurrentData());
        this.close();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProgramEditor);
